import { state } from '@/store/decommissioned/state';
import { getters } from '@/store/decommissioned/getters';
import { actions } from '@/store/decommissioned/actions';
import { mutations } from '@/store/decommissioned/mutations';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
